import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';

export type DateTimeInputProps = {} & DateTimePickerProps<any>;

export function DateTimeInput(props: DateTimeInputProps) {
  return <DateTimePicker slotProps={{ textField: { size: 'small' } }} {...props} />;
}
